module.exports = __webpack_public_path__ + "static/img/513.dff19837.jpg";